<template>

  <div>
    <div class="breadcrumb-list">
      <ol class="breadcrumb">
        <li class="breadcrumb-item active">Settings</li>
      </ol>
    </div>
    <div class="main-box two-column">
      <!--      sidebar setting start-->
      <sidebar></sidebar>
      <!--      sidebar setting end-->
      <div class="setting-info-wrp">
        <!-- location -->
        <div class="loacatoin-box">
          <div class="sett-head">
            <h1>Edit locations for <span class="text-capitalize">{{ company_name }}</span></h1>
            <p>On this page you can edit or create locations for use in CleverStaff. Locations can be used if you have
              different departments or physical addresses.</p>
          </div>
          <div class="sett-head">
            <h2>Existing locations:</h2>
            <p>You haven't created any locations. It's okay, you don't have to. Maybe you only need one location, which
              is covered by your account name: <b class="text-capitalize">{{ company_name }}</b>. You can create a new location if you need to separate
              schedules from your existing <b class="text-capitalize">{{ company_name }}</b> location and a new location.</p>
          </div>
          <div class="input-group">
            <div class="row mb-10">
              <div class="col-6">
                <div class="row">
                  <div class="col-lg-12">
                    <label >Title <span class="text-danger">*</span></label>
                    <div class="form-group">
                      <input type="text" placeholder="Title" v-model="title" id="title" class="form-control text-capitalize">
                    </div>
                  </div>
                  <div class="col-lg-12">
                    <label >Address <span class="text-danger">*</span></label>
                    <div class="form-group">
                      <input type="text" placeholder="Address" id="address" class="form-control"
                             ref="autocomplete">
                    </div>
                  </div>
                  <div class="col-lg-4">
                    <label >Latitude <span class="text-danger">*</span></label>
                    <div class="form-group">
                      <input type="text" placeholder="Latitude" v-model="latitude" class="form-control" readonly>
                    </div>
                  </div>
                  <div class="col-lg-4">
                    <label >Longitude <span class="text-danger">*</span></label>
                    <div class="form-group">
                      <input type="text" placeholder="Longitude" v-model="longitude" class="form-control" readonly>
                    </div>
                  </div>
                  <div class="col-lg-4">
                    <div class="form-group">
                      <label >Radius</label>
                      <input type="text" placeholder="Radius" v-model="radius" class="form-control">
                      <small>Set Radius for employee attendance in meters</small>
                    </div>
                  </div>
                  <div class="col-lg-12 text-right mb-10">
                    <button @click="saveCompanyLocation" class="btn btn-info" type="button">Save</button>
                  </div>
                </div>
              </div>
              <div class="col-6">
                <div id="map"></div>
              </div>
            </div>
          </div>

          <table class="table">
            <thead>
            <th class="text-page">Title</th>
            <th class="text-page">Address</th>
            <th class="text-page">Latitude</th>
            <th class="text-page">Longitude</th>
            <th class="text-page">Radius</th>
            <th class="text-page" data-toggle="tooltip" data-placement="bottom" title="">Restrict (i)</th>
            <th class="text-center text-page">Actions</th>
            </thead>
            <tbody>
            <tr v-for="location in locations" :key="location.id">
              <td class="text-page text-capitalize">{{ location.title }}</td>
              <td class="text-page">{{ location.address }}</td>
              <td class="text-page">{{ location.lat }}</td>
              <td class="text-page">{{ location.lng }}</td>
              <td class="text-page">{{ location.radius }}</td>
              <td class="text-page"><input type="checkbox" :value="location.id" v-model="isAllowedRadius" @change="allowRadiusCheck"></td>
              <td class="text-center">
                <span class="ico-pencil text-primary" style="cursor: pointer;" @click="editLocation(location.id)"></span>
                <span class="ico-delete text-danger ml-5" style="cursor: pointer;" @click="deleteLocation(location.id)"></span>
              </td>
            </tr>
            <tr v-if="!locations.length">
              <td colspan="5" class="text-center text-page">No data found.</td>
            </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>

</template>
<style scoped>
.table tr {
  border-top: none;
}
</style>
<script>
import sidebar from "./sidebar";
import Swal from "sweetalert2";
import { required } from "vuelidate/lib/validators";

export default {
  components: {
    sidebar
  },
  props: [],
  data() {
    return {
      isEdit: false,

        title: null,
        address: null,
        latitude: null,
        longitude: null,
        radius: 500,


      map: null,
      marker: null,
      circle: null,
      id: null,
      locations: [],
      company_id: this.$store.getters.getSelectedCompany.id,
      company_name: this.$store.getters.getSelectedCompany.name,
      location: null,
      isAllowedRadius:[]
    }
  },
  validations: {
    form: {
      title: { required },
      email: { required }
    }
  },

  watch: {
    radius: function(val, oldVal) {
      let scope = this;
      if(this.circle != null) {
        this.circle.setMap(null);
      }
      let map = this.map;
      if(this.radius != null){
        scope.circle = new google.maps.Circle({
          map: map,
          radius: parseInt(scope.radius),    // 10 miles in metres
          fillColor: '#AA0000'
        });
        scope.circle.bindTo('center', scope.marker, 'position');
      }
    }
  },
  created() {
    this.getLocations();
  },
  mounted() {
    this.initMap();
    this.registerLocation();
    $(function () {
      $('[data-toggle="tooltip"]').tooltip()
    });
  },
  methods: {
    allowRadiusCheck(event){
      this.$axios({
        method: "post",
        data: {id:event.target.value,is_allowed:event.target.checked},
        url: this.$RadiusAllowForAttendance,
        headers: this.getAuthHeader(),
      }).then((res) => {
        if (res.data.status == 200) {
          new Swal({
          title: event.target.checked?"Check radius allowed for attendance":"Check radius disallowed for attendance",
          icon: "success",
          text: "",
          type: "success",
          confirmButtonColor: "#3085d6",
        })
        }
      });
    },
    initMap() {
      const myLatLng = {lat: 31.5198893, lng: 74.3508756};
      this.map = new google.maps.Map(document.getElementById("map"), {
        zoom: 15,
        center: myLatLng,
        styles: [
          {
            featureType: "poi",
            elementType: "labels",
            stylers: [
              { visibility: "off" }
            ]
          }
        ]
      });
    },
    registerLocation(){
      let scope = this;
      let map = this.map;
      const autocomplete = new google.maps.places.Autocomplete((this.$refs.autocomplete));
      autocomplete.addListener('place_changed', function () {
        scope.latitude = autocomplete.getPlace().geometry.location.lat();
        scope.longitude = autocomplete.getPlace().geometry.location.lng();
        scope.addMarker();
      });
    },
    addMarker(scope = this){
      let map = this.map;
      let latLng = {lat: scope.latitude, lng: scope.longitude};
      scope.marker = new google.maps.Marker({
        position: latLng,
        map,
        animation: google.maps.Animation.DROP,
        draggable: true
      });
      this.map.setCenter(latLng);

      if(this.radius != null){
        scope.circle = new google.maps.Circle({
          map: map,
          radius: parseInt(scope.radius),    // 10 miles in metres
          fillColor: '#AA0000'
        });
        scope.circle.bindTo('center', scope.marker, 'position');
      }

      google.maps.event.addListener(scope.marker, 'dragend', function () {
        let geocoder = new google.maps.Geocoder();
        geocoder.geocode({'latLng': this.getPosition()}, function(results, status) {
          if (status == google.maps.GeocoderStatus.OK) {
            if (results[0]) {
              scope.$refs['autocomplete'].value = results[0].formatted_address;
            }
          }
        });
        scope.latitude = this.getPosition().lat();
        scope.longitude = this.getPosition().lng();
      });
    },
    saveCompanyLocation(){
      let url = this.$locations;
      let method = 'post';
      let message = "Created successfully";

      if(this.isEdit){
        url = this.$locations+'/'+this.location.id;
        method = 'patch';
        message = "Updated successfully";
      }

      this.$axios({
        method: method,
        data: {
          address: this.$refs['autocomplete'].value,
          title: this.title,
          latitude: this.latitude,
          longitude: this.longitude,
          radius: this.radius,
          company_id: this.company_id
        },
        url: url,
        headers: this.getAuthHeader()
      }).then((res) => {
        if (res.data.status === 200) {
          this.resetForm();
          $root.$toast.success(message);
          this.getLocations();
        }
      });
    },

    resetForm(){
      this.$refs['autocomplete'].value = null;
      this.title = null;
      this.latitude = null;
      this.longitude = null;
      this.radius = null;
      this.isEdit = false;
      this.marker.setMap(null);
      if(this.circle != null) {
        this.circle.setMap(null);
      }
    },

    deleteLocation(id){
      let params = {
        company_id: this.company_id
      };
      new Swal({
        title: "Delete Location?",
        icon: "warning",
        text: "Are you sure? You won't be able to revert this!",
        type: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        confirmButtonText: "Yes, Delete it!"
      }).then((result) => {
        if (result.value) {
          this.$axios.delete(this.$locations+"/"+id, {
            params: params,
            headers: this.getAuthHeader(),
          }).then(res => {
            if (res.data.status === 200) {
              this.resetForm();
              this.getLocations();
              $root.$toast.error('Deleted successfully.');
            }
          });
        }
      });
    },

    editLocation(id){
      if(this.marker != null) {
        this.marker.setMap(null);
      }
      if(this.circle != null) {
        this.circle.setMap(null);
      }
      let params = {
        company_id: this.company_id
      };
      this.$axios.get(this.$locations+"/"+id, {
        params: params,
        headers: this.getAuthHeader(),
      }).then(res => {
        if (res.data.status === 200) {
          this.location = res.data.result;
          this.$refs.autocomplete.value = this.location.address;
          this.latitude = parseFloat(this.location.lat);
          this.longitude = parseFloat(this.location.lng);
          this.title = this.location.title;
          this.radius = this.location.radius;
          this.isEdit = true;
          this.addMarker();
        }
      });
    },

    getLocations(){
      let params = {
        company_id: this.company_id
      };

      this.$axios.get(this.$locations, {
        params: params,
        headers: this.getAuthHeader(),
      }).then(res => {
        if (res.data.status === 200) {
          this.locations = res.data.result;
          this.locations.map((loc) => loc.is_attendance_radius==1?this.isAllowedRadius.push(loc.id):0);
        }
      });
    }
  }
}
</script>
<style scoped>
#map {
  height: 100%;
}
</style>
